import react from "react";

export const SurveyContext = react.createContext({
    submitAnswer: null,
    submitSurveyForm: null,
    getCurrentQuestion: null,
    getSurveyResultAsync: null,
});
